import script from "./OverviewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OverviewPage.vue?vue&type=script&setup=true&lang=js"

import "./OverviewPage.vue?vue&type=style&index=0&id=1ee3efb9&lang=sass&scoped=true"

import exportComponent from "/home/goran/projects/plodine/plodine/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ee3efb9"]])

export default __exports__